import {
  isTablet,
  Position,
  StaticTooltip,
} from "@customer-tools-web/component-ui/lib";
import { LabelWrap, MenuTag, TooltipContentWrapper } from "./NavigatorLink";
import * as React from "react";
import { useI18N } from "@customer-tools-web/component-i18n";

export interface Props {
  onConfirmSpecialistSelfServeTooltip: () => void;
  screenWidth: number;
  isDrawerOpen: boolean;
}
const SpecialistSelfServeOnboardingTooltip = (props: Props) => {
  const { onConfirmSpecialistSelfServeTooltip, screenWidth, isDrawerOpen } =
    props;
  const { t } = useI18N();

  return (
    <StaticTooltip
      okText={"Got it"}
      onOk={() => onConfirmSpecialistSelfServeTooltip()}
      hide={isTablet(screenWidth) && !isDrawerOpen}
      position={Position.BOTTOM}
      customCss={
        isTablet(screenWidth) && isDrawerOpen
          ? {
              arrow: {
                left: 15,
              },
            }
          : undefined
      }
      content={
        <TooltipContentWrapper>
          <div className={"title"}>Introducing ‘Area & Condo Specialist‘</div>
          <div className={"content"}>
            Book and become Area & Condo Specialist at your own convenience.
          </div>
        </TooltipContentWrapper>
      }
    >
      <LabelWrap>
        {" "}
        {t("nav.listings")} <MenuTag pattern={1}>NEW</MenuTag>
      </LabelWrap>
    </StaticTooltip>
  );
};

export default SpecialistSelfServeOnboardingTooltip;
